import React, { useState } from "react"
import dayjs from "dayjs"
import "../../Styles/Reservation.css"
import { Link } from "react-router-dom"
import UseallOverview from "../Componentslogic/UseAlloverview"

const DeliveryOrdersPage = () => {
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"))
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"))
  const [selectedFilter, setSelectedFilter] = useState("All")
  const [searchQuery, setSearchQuery] = useState("")

  const {
    data: deliveryData,
    loading,
    hasMore,
    nextPage,
  } = UseallOverview("DeliveryOrders", startDate, endDate)

  const getStatus = (order) => {
    if (order.delivered) return { text: "Delivered", className: "Delivered" }
    if (order.ontheWay) return { text: "On the Way", className: "fulfilled" }
    if (order.Donepreparing)
      return { text: "Done Preparing", className: "Done" }
    if (order.preparing) return { text: "Preparing", className: "unfulfilled" }
    return { text: "Placed", className: "pending" }
  }

  const handleFilterClick = (filter) => {
    setSelectedFilter(filter)
  }

  const filteredData = deliveryData.filter((order) => {
    const { text } = getStatus(order)

    const matchesSearch =
      !searchQuery || order.orderNumber.includes(searchQuery)
    const matchesFilter = selectedFilter === "All" || text === selectedFilter

    return matchesSearch && matchesFilter
  })

  const handleInputClick = (e) => {
    e.preventDefault()
    e.target.showPicker()
  }
  const formatTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "N/A" // Handle missing timestamp

    const date = new Date(timestamp.seconds * 1000) // Convert Firestore Timestamp
    return `${date.toLocaleDateString()} at ${date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`
  }

  return (
    <div className="dashboard-container">
      <main className="main-content">
        {/* Date Filters */}
        <div className="d-flex justify-content-center mb-3">
          <div className="d-flex flex-column align-items-center mx-3">
            <label htmlFor="start-date" className="mb-2">
              Start Date
            </label>
            <input
              id="start-date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              onClick={handleInputClick}
              className="date-picker"
            />
          </div>
          <div className="d-flex flex-column align-items-center">
            <label htmlFor="end-date" className="mb-2">
              End Date
            </label>
            <input
              id="end-date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              onClick={handleInputClick}
              className="date-picker"
            />
          </div>
        </div>

        {/* Search and Filter Section */}
        <header className="header">
          <input
            type="text"
            placeholder="Search by order number..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-box"
          />
        </header>

        <section className="summary-cards">
          <div
            className={`card ${
              selectedFilter === "All" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("All")}
          >
            All Orders
          </div>
          <div
            className={`card ${
              selectedFilter === "Placed" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("Placed")}
          >
            Placed
          </div>
          <div
            className={`card ${
              selectedFilter === "Preparing" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("Preparing")}
          >
            Preparing
          </div>
          <div
            className={`card ${
              selectedFilter === "Done Preparing" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("Done Preparing")}
          >
            Done Preparing
          </div>
          <div
            className={`card ${
              selectedFilter === "On the Way" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("On the Way")}
          >
            On the Way
          </div>
          <div
            className={`card ${
              selectedFilter === "Delivered" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("Delivered")}
          >
            Delivered
          </div>
        </section>

        {/* Orders Table */}
        <section className="orders-table">
          <table>
            <thead>
              <tr>
                <th>Order</th>
                <th>Date and Time</th>
                <th>Customer</th>
                <th>Total</th>
                <th>Delivery</th>
                <th>Address</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((order, index) => {
                const { text, className } = getStatus(order)
                return (
                  <tr key={index}>
                    <td>{order.orderNumber}</td>
                    <td>{formatTimestamp(order.createdAt)}</td>
                    <td>{order.userName}</td>
                    <td>{order.totalAmount} EGP</td>
                    <td>
                      <span className={`status ${className}`}>{text}</span>
                    </td>
                    <td>{`${order.address.street} - ${order.address.buildingName}`}</td>
                    <td>
                      <Link to={`/adminDeliveryorderdetails/${order.id}`}>
                        <button className="btns-Admin">View</button>
                      </Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </section>

        {/* Pagination */}
        {loading && <p>Loading...</p>}

        {hasMore && !loading && (
          <div className="d-flex justify-content-center align-items-center">
            <button className="btn-Load" onClick={() => nextPage()}>
              Load More
            </button>
          </div>
        )}
      </main>
    </div>
  )
}

export default DeliveryOrdersPage
